import React from "react";

interface MastercardIconProps {
  size?: number;
}

export const MastercardIcon: React.FC<MastercardIconProps> = ({
  size = 34,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 291.791 291.791"
    fill="none"
    style={{ display: "block" }}
  >
    <title>Mastercard icon</title>
    <g>
      <path
        style={{ fill: "#E2574C" }}
        d="M182.298,145.895c0,50.366-40.801,91.176-91.149,91.176S0,196.252,0,145.895
        s40.811-91.176,91.149-91.176S182.298,95.538,182.298,145.895z"
      />
      <path
        style={{ fill: "#F4B459" }}
        d="M200.616,54.719c-20.442,0-39.261,6.811-54.469,18.181l0.073,0.009
        c2.991,2.89,6.291,4.924,8.835,8.251l-18.965,0.301c-2.972,3-5.68,6.264-8.233,9.656H161.3c2.544,3.054,4.896,5.708,7.03,9.081
        h-46.536c-1.705,2.936-3.282,5.954-4.659,9.09h56.493c1.477,3.127,2.799,5.489,3.921,8.799h-63.76
        c-1.012,3.146-1.878,6.364-2.535,9.646h68.966c0.675,3.155,1.194,6.072,1.55,9.045h-71.884c-0.301,3-0.456,6.045-0.456,9.118
        h72.859c0,3.228-0.228,6.218-0.556,9.118h-71.847c0.31,3.091,0.766,6.127,1.368,9.118h68.856c-0.711,2.954-1.532,5.926-2.562,9.008
        h-63.969c0.966,3.118,2.143,6.145,3.428,9.099h56.621c-1.568,3.319-3.346,5.972-5.306,9.081h-46.691
        c1.842,3.191,3.875,6.236,6.081,9.154l33.589,0.501c-2.863,3.437-6.537,5.507-9.884,8.516c0.182,0.146-5.352-0.018-16.248-0.191
        c16.576,17.105,39.744,27.772,65.446,27.772c50.357,0,91.176-40.82,91.176-91.176S250.981,54.719,200.616,54.719z"
      />
    </g>
  </svg>
);
